/** "Identifikátor události je: " */
export const LOC_KEY_ERROR_EVENT_ID = "GUI-487438";
/** "Kontaktujte správce aplikace a předejte mu identifikátor události." */
export const LOC_KEY_ERROR_NOTICE = "GUI-487456";
/** Je nutná aktualizace */
export const LOC_KEY_ERROR_UPDATE_REQUIRED = "GUI-621093";
/** Chybějící aplikace */
export const LOC_KEY_ERROR_MISSING_CNA_APP = "GUI-623882";
/** Chybějící rozšíření */
export const LOC_KEY_ERROR_MISSING_CWE_EXTENSION = "GUI-625595";
/** Neplatná podmínka filtru */
export const LOC_KEY_ERROR_INVALID_FILTER = "GUI-691823";
/** U některého z použitých atributů není filtrování dovoleno. \n\nNepovolené atributy: @0 */
export const LOC_KEY_ERROR_INVALID_FILTER_ATTRIBUTE = "GUI-692779";
/** Použitá podmínka rozšířeného filtru není validní a nelze ji použít. \n\nNevalidní hodnoty: @0 */
export const LOC_KEY_ERROR_INVALID_EXTENDED_FILTER_VALUES = "GUI-691826";
/** Použitá podmínka rozšířeného filtru není validní a nelze ji použít. */
export const LOC_KEY_ERROR_INVALID_EXTENDED_FILTER = "GUI-691824";
/** Nepodařilo se načíst žádná data */
export const LOC_KEY_ERROR_NO_DATA = "GUI-691883";
/** Zrušte nastavené filtry a zkuste akci zopakovat. */
export const LOC_KEY_ERROR_CLEAR_AND_RETRY = "GUI-691884";
/** V případě přetrvání problému kontaktujte správce systému. */
export const LOC_KEY_ERROR_CONTACT_ADMIN = "GUI-691885";
/** Došlo k chybě při zpracování požadavku indexed DB. */
export const LOC_KEY_ERROR_INDEXED_BD = "GUI-622485";
/** Pokud problém přetrváva zkuste se odhlásit a znovu přihlásit do aplikace. */
export const LOC_KEY_ERROR_RELOG_AND_RETRY = "GUI-622486";
/** Odhlásit */
export const LOC_KEY_ERROR_LOGOUT = "GUI-337140";
/** Uložiště je bohužel nedostupné */
export const LOC_KEY_ERROR_STORAGE_UNAVAILABLE = "GUI-624372";
/** Se soubory nyní nelze pracovat. Zkuste se vrátit později. */
export const LOC_KEY_ERROR_FILES_UNAVAILABLE = "GUI-624373";
/** Chyba úložiště */
export const LOC_KEY_ERROR_STORAGE_ERROR = "GUI-624374";
/** Něco se nepovedlo. */
export const LOC_KEY_ERROR_GENERIC_FAIL = "GUI-533187";
/** Vypadá to, že server odmítá spolupracovat. Zkuste akci zopakovat. */
export const LOC_KEY_ERROR_GENERIC_RETRY = "GUI-533991";
/** Nejde to. */
export const LOC_KEY_ERROR_GENERIC_UNABLE = "GUI-533167";
/** Bohužel nemáte práva pro zobrazení tohoto formuláře. */
export const LOC_KEY_ERROR_NO_RIGHTS_FORM = "GUI-533169";
/** Definice formuláře nenalezena */
export const LOC_KEY_ERROR_FORM_DEFINITION_NOT_FOUND = "GUI-606223";
/** Nebyl zadán název formuláře. */
export const LOC_KEY_ERROR_MISSING_FORM_NAME = "GUI-624401";
/** Formulář '@0' se nepodařilo otevřít.\n\nV případě opakovaných problémů se obraťte na administrátora aplikace. */
export const LOC_KEY_ERROR_UNABLE_TO_OPEN_FORM = "GUI-478533";
/** Záznamu není přiřazen formulář.\n\nV případě opakovaných problémů se obraťte na administrátora aplikace. */
export const LOC_KEY_ERROR_NO_ASSOCIATED_FORM = "GUI-624399";
/** Zadali jste chybné jméno nebo heslo. */
export const LOC_KEY_ERROR_WRONG_CREDENTIALS = "GUI-533185";
/** Nemáte dostatečná oprávnění pro zobrazení záznamu nebo byl záznam vymazán. */
export const LOC_KEY_ERROR_INSUFFICIENT_RIGHTS = "GUI-611220";
/** '@0' nelze měnit. */
export const LOC_KEY_ERROR_UNABLE_TO_MODIFY = "GUI-564867";
/** Nemáte právo provést akci. */
export const LOC_KEY_ERROR_INSUFFICIENT_RIGHTS_RUN_ACTION = "GUI-665099";
/** Akci nebylo možné spustit. */
export const LOC_KEY_ERROR_UNABLE_TO_RUN_ACTION = "GUI-663025";
/** Žádný z vybraných záznamů nesplňuje podmínku pro její spuštění. */
export const LOC_KEY_ERROR_CONDITION_NOT_MET = "GUI-660137";
/** Byli jste odhlášeni z aplikace. */
export const LOC_KEY_ERROR_LOGGED_OUT = "GUI-484396";
/** Vypršela platnost bezpečnostního tokenu. */
export const LOC_KEY_ERROR_SECURITY_TOKEN_EXPIRED = "GUI-609463";
/** Vypadá to, že server odmítá spolupracovat. Zkuste akci zopakovat. */
export const LOC_KEY_ERROR_SERVER_UNAVAILABLE = "GUI-533991";
/** Nepovedlo se vytvořit podpis */
export const LOC_KEY_ERROR_UNABLE_TO_CREATE_DIGITAL_SIGNATURE = "GUI-624369";
/** Aplikace CryptoNativeApp byla ukončena. Opakujte vytvoření podpisu. */
export const LOC_KEY_ERROR_CNA_EXITED = "GUI-624370";
/** Aplikace provedla něco, co jsme nečekali. Zkuste to znovu. V případě opakování problému se obraťte na správce systému */
export const LOC_KEY_ERROR_GENERIC_FAIL_RETRY = "GUI-569655";
/** Chyba při vytváření konfiguračního objektu selectionParams. */
export const LOC_KEY_ERROR_CNA_SELECTIONPARAMS = "GUI-765250";
/** Nebyl nalezen žádný certifikát odpovídající zadaným parametrům. */
export const LOC_KEY_ERROR_CNA_NO_CERTIFICATE_FOUND = "GUI-765251";
/** Zadaným parametrům odpovídá více než 1 certifikát. */
export const LOC_KEY_ERROR_CNA_TOO_MANY_CERTIFICATES_FOUND = "GUI-765252";
